export default __webpack_public_path__ + "static/media/img9.6a9f7fbb.PNG";